module.exports = __webpack_public_path__ + "static/img/banner.2acb2929.png";